const React = require("react");
const {openPopupWindow} = require("../../../../../../../emitters/popup");
const Popup = require("../../../../../Popup/C");
const {FormFooterAgreement, FormWrapper} = require("../../../../../FormHandlers");
const {apiAdminTrxReset} = require("../../../../../../../api/admin/transactions");

module.exports = (data, update) => {
  openPopupWindow((setPopupState, popup) => {

    const {close} = popup;

    const resultModalData = [
      'Reset completed',
      `You\'ve made a reset for #${data.id} transaction.`
    ];

    const onSubmit = () => (
      apiAdminTrxReset({id: data.id})
    );

    const onResult = () => {
      update();
      close();
    }

    return () => {
      return (
        <Popup
          caption={(
            <div className="layoutRow aiC">
              <h2 className="dB m0 mr20 p0 f23 lh34 fw7">
                Reset
              </h2>
              <span className="dB f16 lh24 fw7">
                {data.id}
              </span>
            </div>
          )}
        >
          <>
            <div className="mt20">Do you want to reset #{data.id} transaction?</div>
            <FormWrapper
              onSubmit={onSubmit}
              resultModalData={resultModalData}
              onResult={onResult}
            >{(formCtx) => (
                <FormFooterAgreement
                  submitBtnData={{
                    text: 'Proceed',
                    formCtx
                  }}
                  additionalBtnsList={[
                    {
                      text: 'Cancel',
                      onClick: close
                    }
                  ]}
                />
              )}</FormWrapper>
          </>
        </Popup>
      )
    }
  })
}
